module.exports = __webpack_public_path__ + "static/phyppz-c3167623fd8100d0d21e28c8f2428515.jpg";